import { styled } from '@mui/material';
import { breakpoints } from '../theme/theme';
import { COLORS } from '../theme/color';

export const Container = styled('div')`
  width: 100%;
  background-color: #f8f7f7;
  position: relative;
  padding: 20px 2rem 0;
  @media (max-width: ${breakpoints.sm}px) {
    padding: 45px 4.5vw 0;
  }
`;

export const MainGridCon = styled('div')``;

export const CategoriesLeft = styled('div')`
  @media (max-width: ${breakpoints.md}px) {
    display: none;
  }
  a {
    min-width: 280px;
  }
  a.active,
  active:hover {
    background-color: ${COLORS.MainBlue};
    color: #fff;
    font-weight: 500;
  }
`;

export const AccountLeft = styled('div')`
  @media (max-width: ${breakpoints.md}px) {
    display: none;
  }
  a {
    height: 40px;
    min-width: 275px;
  }
  a.active {
    background-color: ${COLORS.SecBlue};
    color: ${COLORS.MainBlue};
    font-weight: 500;
    position: relative;
  }
  a.active:after {
    content: '';
    width: 4px;
    border-radius: 4px;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    background-color: ${COLORS.MainBlue};
  }
`;

export const Right = styled('div')`
  width: 100%;
  min-width: 0;
`;
